<template>
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th 
          @click="sortBy('written_at')"
          v-bind:class="[(sortField == 'written_at') ? 'sorted' : '', (sortDir == 'desc') ? 'desc' : 'asc']"
        >Date</th>
        <th 
          @click="sortBy('number')"
          v-bind:class="[(sortField == 'number') ? 'sorted' : '', (sortDir == 'desc') ? 'desc' : 'asc']"
        >Number</th>
        <th 
          @click="sortBy('amount')"
          v-bind:class="[(sortField == 'amount') ? 'sorted' : '', (sortDir == 'desc') ? 'desc' : 'asc']"
        >Amount</th>
        <th 
          @click="sortBy('full_name')"
          v-bind:class="[(sortField == 'full_name') ? 'sorted' : '', (sortDir == 'desc') ? 'desc' : 'asc']"
        >Participant</th>
        <th>Reason</th>
        <th 
          @click="sortBy('visit_window_id')"
          v-bind:class="[(sortField == 'visit_window_id') ? 'sorted' : '', (sortDir == 'desc') ? 'desc' : 'asc']"                >Visit</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="check in sortedChecks">
        <td>{{ check.written_at.format('MM/DD/YYYY') }}</td>
        <td>{{ check.number }}</td>
        <td>{{ check.amount }}</td>
        <td>{{ check.participant.full_name }} ({{ check.participant.ccs_id }})</td>
        <td>{{ check.activities.join(', ') }}</td>
        <td>{{ check.visit_window_id }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script setup>
  import { ref, computed, onMounted } from 'vue'
  import Resource from '../../resources/Resource.js'

  let sortField = ref('written_at')
  let checks = ref([])
  let sortDir = ref('asc')
  let ChecksResource = new Resource({
    baseUrl: '/api/checks',
    dates: ['written_at'],
    name: 'ChecksResource'
  })

  const sortedChecks = computed(() => {
    return checks.value.sort(function (a, b) {
      if (sortField.value == 'full_name') {
        a = a.participant['full_name'].toLowerCase();
        b = b.participant['full_name'].toLowerCase();
      }

      a = a[sortField.value];
      b = b[sortField.value];

      var dir = (sortDir.value == 'asc') ? 1 : -1;
      if (a > b) {
          return 1*dir;
      }
      if (a < b) {
          return -1*dir;
      }
      return 0;
    })
  })
        
  function sortBy(field) {
    sortDir.value = (sortField.value == field && sortDir.value == 'asc') ? 'desc' : 'asc'
    sortField.value = field
  }

  onMounted(() => {
    ChecksResource.all({with: 'participant'})
        .then(function (response) {
          checks.value = response.data
        })
  })
    
</script>

<style scoped>
  th.sorted {
      cursor: pointer;
  }
  th.sorted.asc:after {
    /*background-color: #f0f;*/
    content: ' ▲';
    color: #999;
    font-size: .9em;
  }
  th.sorted.desc:after {
    /*background-color: #0f0;*/
    content: ' ▼';
    color: #999;
    font-size: .9em;
  }
</style>